import React from 'react';
import { useEmployeeRequestFormsQuery } from '../../../__generated__/graphql';
import Loading from '../../Loading';
import { RequestForm } from '../RequestForm';

type Props = {
  show: boolean;
  recordType: string;
  showAllRequests: boolean;
  onHide: () => void;
};

export const EmployeeRequestForm: React.FC<Props> = (props) => {
  const { data, loading } = useEmployeeRequestFormsQuery();

  if (loading || !data) {
    return <Loading />;
  }

  //todo: do something with employees in next PR (they are not required here)
  return (
    <RequestForm {...props} requestForms={data.requestForms} employees={[]} />
  );
};
